import { z } from 'zod';

export type Config = z.infer<typeof Config>;

const Flag = z.preprocess((value) => {
  if (typeof value === 'string') {
    return !['false', '0', 'no', 'off'].includes(value.toLowerCase());
  }
  return value;
}, z.boolean());

// const isDev = import.meta.env.DEV;

export const Config = z.object({
  VERSION: z.string().default('0.0.0'),
  BUILDTIME: z.coerce.date().default(new Date()),
  BACKEND: z.url(),
  BACKEND_MESSAGE_HUB: z.url(),
  BACKEND_WEBSITE: z.url(),
  CDN: z.url(),
  BATTERY_WARNING: z.coerce.number().default(0.05),
  BATTERY_CRITICAL: z.coerce.number().default(0.01),
  ENV_ID: z.string(),
  ENV_NAME: z.string(),
  TRACING_COLLECTOR: z.string(),
  MOUSE_SENSOR_THRESHOLD: z.coerce.number().default(850),
  GATEWAY_ID_PREFIXES: z
    .string()
    .default('a84041ffff')
    .transform((value) => value.split(/[\s,;]/)),
  GOOGLE_MAPS_API_KEY: z.string(),

  FEATURE_FEEDBACK: Flag.default(true),
  FEATURE_MAINTENANCE_MODE: Flag.default(true),
  FEATURE_LIGHT_MODE: Flag.default(true),
  FEATURE_DASHBOARD_EXTRAPOLATE: Flag.default(false),
  TESTING: Flag.default(false),
});
